import React from 'react';
import { Dialog, DialogContent, DialogActions, Alert, DialogTitle } from '@mui/material';
import { Localized } from '@fluent/react';
import { If } from '../../../app/If';
import { DeleteButton } from '../../../app/components/DeleteButton';
import { CancelButton } from '../../../app/components/CancelButton';

export interface DocumentSectionDeleteDialogProps {
    deleting: boolean;
    hasSubSections: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export const DocumentSectionDeleteDialog: React.FC<DocumentSectionDeleteDialogProps> = ({
    deleting,
    hasSubSections,
    onConfirm,
    onCancel,
}) => {
    return (
        <Dialog open={true} onClose={onCancel}>
            <DialogTitle
                sx={{
                    bgcolor: (theme) => theme.palette.grey[100],
                    borderBottom: '1px solid',
                    borderColor: 'divider',
                }}
            >
                <Localized id="confirm-delete">
                    <span>_Czy na pewno chcesz usunąć?</span>
                </Localized>
            </DialogTitle>
            <DialogContent
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                }}
            >
                <If condition={hasSubSections}>
                    <Alert severity="warning" variant="standard">
                        <Localized id="document-delete-section-warning">
                            <span>_Podsekcje zostaną również usunięte</span>
                        </Localized>
                    </Alert>
                </If>
            </DialogContent>
            <DialogActions>
                <DeleteButton loading={deleting} onClick={onConfirm} />
                <CancelButton loading={deleting} onClick={onCancel} />
            </DialogActions>
        </Dialog>
    );
};
